export default __webpack_public_path__ + "42e3b05e79c640987297337003dabf84.jpg";